define.alias("shared/utils/formatters/format-hashtag-trends", "media/utils/formatters/format-hashtag-trends");